import React from 'react';
import PropTypes from 'prop-types';
import { Band } from 'components/layout';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

const propTypes = {
  technicians: PropTypes.array,
  options: PropTypes.object,
  areas: PropTypes.array
};

const CubsListTable = ({ cubs, options, }) => {
  return (
    <Band dark>
      <div className="table-wrap">
        <BootstrapTable
          bodyContainerClass="px-2"
          className=""
          trClassName="app-table-row"
          version="4"
          data={cubs}
          bordered={false}
          options={options}
        >
          <TableHeaderColumn
            isKey
            className="app-table-header"
            columnClassName="keyColumn"
            dataField="cubserialnumber"
            hidden
          />
          <TableHeaderColumn
            width="20%"
            className="app-table-header"
            dataField="cubshortname"
            dataSort
          >
            Name
          </TableHeaderColumn>
          <TableHeaderColumn
            width="20%"
            className="app-table-header"
            dataField="cubserialnumber"
            dataSort
          >
            Serial Number
          </TableHeaderColumn>
            <TableHeaderColumn
            width="20%"
            className="app-table-header"
            dataField="chasisnumber"
            dataSort
          >
            Chasis Number
          </TableHeaderColumn>
        
  
          <TableHeaderColumn
            width="20%"
            className="app-table-header"
            dataField="notes"
          >
            Notes
          </TableHeaderColumn>
          <TableHeaderColumn
            className="app-table-header"
            columnClassName="mobileToggleColumn hidden-sm hidden-md hidden-lg"
          />
        </BootstrapTable>
      </div>
    </Band>
  );
};

CubsListTable.propTypes = propTypes;

export default CubsListTable;
